<template>
  <section class="oa-context">
    <div class="oa-context__main">
      <span class="oa-context__label">Current Order</span>
      <div class="oa-context__uuid">
        <a
          :href="`/ryd-customer-support/find-data-by-order-uuid?uuid=${encodeURIComponent(uuid)}`"
          target="_blank"
          rel="noopener"
          class="text-decoration-none"
          title="Open Order Details in Customer Support (new tab)"
        >
          <code>{{ uuid }}</code>
          <i class="fa fa-external-link ms-1 small" aria-hidden="true"></i>
        </a>
        <button type="button" class="btn btn-link btn-sm" title="Copy UUID" @click="$emit('copy')">
          <i class="fa fa-copy"></i>
        </button>
      </div>
    </div>
    <div class="oa-context__facts">
      <span v-for="chip in chips" :key="chip.label"
        ><small>{{ chip.label }}</small
        ><strong>{{ chip.value }}</strong></span
      >
    </div>
    <div class="oa-context__actions">
      <span class="oa-context__state" :class="`oa-context__state--${state.tone}`"
        ><i class="fa me-1" :class="state.icon"></i>{{ state.label }}</span
      >
      <button type="button" class="btn btn-outline-secondary btn-sm" @click="$emit('reset')">
        <i class="fa fa-refresh me-1"></i>Lookup Another
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  uuid: string;
  chips: Array<{ label: string; value: string }>;
  state: { tone: string; icon: string; label: string };
}>();
defineEmits(['copy', 'reset']);
</script>

<style scoped>
.oa-context {
  display: grid;
  grid-template-columns: minmax(16rem, 1.2fr) 2fr auto;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem 1.2rem;
  border: 1px solid #b6ccfe;
  border-radius: 0.8rem;
  background: #f8faff;
}
.oa-context__label,
.oa-context__facts small {
  display: block;
  color: #667085;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}
.oa-context__uuid {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.25rem;
}
.oa-context__uuid code {
  overflow: hidden;
  color: #175cd3;
  font-size: 0.78rem;
  text-overflow: ellipsis;
}
.oa-context__uuid .btn {
  color: #175cd3;
}
.oa-context__facts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.oa-context__facts > span {
  padding: 0.45rem 0.6rem;
  border: 1px solid #e4e7ec;
  border-radius: 0.45rem;
  background: #fff;
}
.oa-context__facts strong {
  display: block;
  margin-top: 0.1rem;
  color: #344054;
  font-size: 0.75rem;
}
.oa-context__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.oa-context__state {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.65rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
}
.oa-context__state--primary {
  color: #175cd3;
  background: #eff4ff;
}
.oa-context__state--success {
  color: #027a48;
  background: #ecfdf3;
}
.oa-context__state--warning {
  color: #b54708;
  background: #fffaeb;
}
.oa-context__state--danger {
  color: #b42318;
  background: #fef3f2;
}
.oa-context__state--secondary {
  color: #475467;
  background: #f2f4f7;
}
@media (max-width: 1100px) {
  .oa-context {
    grid-template-columns: 1fr;
  }
  .oa-context__actions {
    justify-content: space-between;
  }
}
</style>
